export const InstructorType = Object.freeze({
    Sales: 0,
    Technical: 1,
    Aruba: 2
});